import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CategoryIcon } from './CategoryIcon';

export function CategoryCard({ id, name, description, color, accent }) {
  const gradient = `linear-gradient(135deg, ${color} 0%, ${accent} 100%)`;

  return (
    <Link
      to={`/shop?category=${id}`}
      className="group relative overflow-hidden rounded-2xl border border-border/70 p-6 flex flex-col justify-between min-h-[180px] text-[#F1E6D3]"
      style={{ background: gradient }}
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity bg-black" />
      <div className="relative z-10">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-sm uppercase tracking-[0.2em] text-[#E7D9C2]">Kategória</p>
            <h3 className="font-display text-xl font-semibold mt-2">{name}</h3>
          </div>
          <CategoryIcon categoryId={id} />
        </div>
        <p className="text-sm text-[#E7D9C2] mt-4">{description}</p>
      </div>
      <div className="relative z-10 mt-6 inline-flex items-center gap-2 text-sm font-medium">
        Fedezd fel
        <ArrowRight className="w-4 h-4" />
      </div>
    </Link>
  );
}
